import { render, staticRenderFns } from "./overview-tab.vue?vue&type=template&id=9550bb98&scoped=true&"
import script from "./overview-tab.vue?vue&type=script&lang=js&"
export * from "./overview-tab.vue?vue&type=script&lang=js&"
import style0 from "./overview-tab.vue?vue&type=style&index=0&id=9550bb98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9550bb98",
  null
  
)

export default component.exports